<div class="text-center">
  <i class="fas fa-envelope-open-text text-primary-700 text-3xl mb-4"></i>
  <h1 class="text-2xl font-bold text-gray-900 mb-2">Validate your email</h1>
  <p class="text-gray-500 mb-6">You should have received a confirmation email from us. Remember to check spam if you don't find it.</p>
</div>

<div class="text-center mb-6">
  <button class="btn btn-ghost btn-sm" *ngIf="!sendingVerificationEmail" (click)="resendVerification()">
    Resend confirmation email
  </button>
  <button class="btn btn-ghost btn-sm" disabled *ngIf="sendingVerificationEmail" type="button">
    <i class="fas fa-circle-notch"></i>
    Processing
  </button>
  <p class="text-sm text-green-600 mt-2" *ngIf="verificationEmailSent">
    <i class="fas fa-check-circle mr-1"></i>
    Verification email sent!
  </p>
</div>

<button class="btn btn-primary w-full" type="button" (click)="checkVerification()" *ngIf="!checkingVerification">
  I validated my email
</button>
<button disabled class="btn btn-processing w-full" type="button" *ngIf="checkingVerification">
  <i class="fas fa-circle-notch"></i>
  Please wait...
</button>

<app-warning-message type="error" title="Not verified yet" message="We couldn't confirm your email is verified yet. Please check your inbox and try again."
                      *ngIf="emailNotVerified"></app-warning-message>
